import React, { useRef } from "react";
import { format } from "date-fns";

import {
  Container,
  Content,
  Card,
  CardFile,
  CardIntegracao as CardIntegracaoStyled,
} from "./styles";
import Header from "../../../components/Header";
import { useEffect } from "react";
import { useState } from "react";

import { api } from "../../../services/api";
import SideBarAdmin from "../../../components/SideBarAdmin";
import Input from "../../../components/Input";
import Alerts from "../../../components/Alerts";

const CardIntegracaoo = ({ integracao }) => {
  console.log(integracao);
  return (
    <CardIntegracaoStyled>
      <header>
        <section>
          <h3>Integração {integracao.id}</h3>
          <p
            style={{
              color:
                integracao.status === 0
                  ? "blue"
                  : integracao.status === 1
                  ? "green"
                  : "red",
            }}
          >
            {integracao.status === 0
              ? "Em Andamento"
              : integracao.status === 1
              ? "Integrada com sucesso"
              : "Integrada com erros"}
          </p>
        </section>
        {format(new Date(integracao.fim), "dd/MM/yyyy HH:mm")}
      </header>
      <section>
        <p>
          <strong>{integracao.alunos_adicionados}</strong> Alunos Novos
        </p>
        {/*         
        <p>
          <strong>{integracao.areas_adicionadas}</strong> Areas Novas
        </p>
        <p>
          <strong>{integracao.cursos_adicionados}</strong> Cursos Novos
        </p>
        <p>
          <strong>{integracao.telefones_adicionados}</strong> Telefones Novos
        </p>
        <p>
          <strong>{integracao.aluno_curso_concluido_adicionados}</strong> Alunos
          em Cursos Concluídos
        </p>
        <p>
          <strong>{integracao.aluno_curso_cursando_adicionados}</strong> Alunos
          em Curso Corrente
        </p>
        <p>
          <strong>{integracao.aluno_curso_concluido_atualizados}</strong> Alunos
          em Cursos Concluintes
        </p>  */}
      </section>
    </CardIntegracaoStyled>
  );
};

function IntegracaoSG7() {
  const headerLinks = [{ label: "Sair", to: "/" }];

  const fileRef = useRef();
  const btnRef = useRef();

  const [integracoes, setIntegracoes] = useState([]);
  const [fileMensagemErro, setFileMensagemErro] = useState("");
  const [mensagem, setMensagem] = useState("");

  const [arquivo, setArquivo] = useState(null);

  useEffect(() => {
    const listarIntegracoes = async () => {
      try {
        const retorno = await api.get("/admin/integracoes-sg7");

        setIntegracoes(retorno.data);
      } catch (e) {
        console.log(e);
      }
    };

    btnRef.current.disabled = true;

    listarIntegracoes();
  }, []);

  const enviar = async () => {
    const dados = new FormData();

    dados.append("arquivo", arquivo);

    btnRef.current.innerHTML = "Enviando... Isso pode demorar um pouco.";
    btnRef.current.disabled = true;

    try {
      const response = await api.post("/admin/integracoes-sg7", dados, {
        headers: {
          "Content-type": `multipart/form-data`,
        },
      });

      setIntegracoes([response.data, ...integracoes]);

      btnRef.current.innerHTML = "Enviar";
      document.querySelector("#file").value = "";
      setArquivo(null);
      btnRef.current.disabled = true;

      setMensagem({
        show: true,
        titulo: "Tudo certo!",
        detalhe: "Integração realizada com sucesso",
      });

      setTimeout(() => {
        setMensagem("");
      }, 3000);
    } catch (error) {
      if (error.response) {
        setMensagem({
          show: true,
          titulo: "Erro",
          detalhe: error.response.data.erro,
        });
      } else {
        setMensagem({
          show: true,
          titulo: "Erro",
          detalhe: "Erro ao enviar, consulte o administrador do sistema",
        });
      }
      console.log(error);

      btnRef.current.innerHTML = "Enviar";
      document.querySelector("#file").value = "";
      setArquivo(null);
      btnRef.current.disabled = true;

      setTimeout(() => {
        setMensagem("");
      }, 3000);
    }
  };

  const handlerImagem = (e) => {
    if (
      e.target.files[0].type !==
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      e.target.value = "";
      setArquivo(null);
      btnRef.current.disabled = true;
      return setFileMensagemErro("A formato do arquivo deve ser .xlsx");
    }
    setFileMensagemErro("");
    setArquivo(e.target.files[0]);
    btnRef.current.disabled = false;
  };

  return (
    <Container>
      <Alerts mensagem={mensagem} setMensagem={setMensagem} tipo="erro" />
      <SideBarAdmin></SideBarAdmin>
      <Header links={headerLinks} theme="black" />
      <Content>
        <Card>
          <h1>Nova integração</h1>
          <CardFile>
            <Input
              type="file"
              id="file"
              ref={fileRef}
              mensagemErro={fileMensagemErro}
              accept=".xlsx"
              handler={handlerImagem}
              style={{ marginBottom: 0 }}
            />
            <button onClick={enviar} ref={btnRef} style={{ marginTop: -5 }}>
              Enviar
            </button>
          </CardFile>
        </Card>
        <hr />
        <Card>
          <h1>Últimas integrações</h1>
        </Card>
        {integracoes.map((i) => (
          <CardIntegracaoo key={i.id} integracao={i} />
        ))}
      </Content>
    </Container>
  );
}

export default IntegracaoSG7;
